import { Box } from '@apia/theme';
import { getLabel } from '@apia/util';
import { SwitchCard } from './SwitchCard';
import { observer } from 'mobx-react-lite';
import { usePermissionsContext } from './Permissions';

const PermissionsList = observer(() => {
  const controller = usePermissionsContext();
  const state = controller.permissions;

  return (
    <Box className="permissions__list">
      {state.users && state.users.length > 0 && (
        <>
          <span>{getLabel('sbtUsers').text}</span>
          <Box as="ul">
            {state.users.map((c) => {
              return (
                <Box as="li" key={c.userId}>
                  <SwitchCard
                    disabled={controller.disabled}
                    label={c.userLogin}
                    align="right"
                    icon="User2"
                    onClose={() =>
                      controller.onChangeUsers(
                        controller.permissions.users.filter(
                          (s) => s.userId !== c.userId,
                        ),
                      )
                    }
                    onSwitch={(isSwitched) => (c.canUpdate = isSwitched)}
                    value={c.canUpdate}
                  />
                </Box>
              );
            })}
          </Box>
        </>
      )}
      {state.pools && state.pools.length > 0 && (
        <>
          <span>{getLabel('lblPool').text}</span>
          <Box as="ul">
            {state.pools.map((c) => {
              return (
                <Box as="li" key={c.poolName}>
                  <SwitchCard
                    label={c.poolName}
                    align="right"
                    icon="Groups"
                    onClose={() =>
                      controller.onChangePools(
                        controller.permissions.pools.filter(
                          (s) => s.poolId !== c.poolId,
                        ),
                      )
                    }
                    onSwitch={(isSwitched) => (c.canUpdate = isSwitched)}
                    value={c.canUpdate}
                  />
                </Box>
              );
            })}
          </Box>
        </>
      )}
    </Box>
  );
});

export default PermissionsList;
